import { getClimateActionQueryDocument } from "@/domain/climate-action/hooks/api/climate-action.gql";
import { type DeleteKeyResultMutation } from "@/graphql/generated/graphql";
import { useMutation } from "@apollo/client";

import { deleteKeyResultMutationDocument } from "./key-result.gql";

export type DeletedKeyResult = DeleteKeyResultMutation["deleteKeyResult"];

export interface UseDeleteKeyResultProps {
  climateActionId: string;
  onCompleted?: (data: DeletedKeyResult) => void;
  onError?: (e: Error) => void;
}

export const useDeleteKeyResult = ({ climateActionId, onCompleted, onError }: UseDeleteKeyResultProps) => {
  const [deleteKeyResult, { loading, error }] = useMutation(deleteKeyResultMutationDocument, {
    onCompleted: onUpdateCompleted,
    onError: onUpdateError,
    refetchQueries: [
      {
        query: getClimateActionQueryDocument,
        variables: { input: { id: climateActionId } },
      },
    ],
  });

  function onUpdateCompleted(data: DeleteKeyResultMutation) {
    if (onCompleted) {
      onCompleted(data.deleteKeyResult);
    }
  }

  function onUpdateError(e: Error) {
    if (onError) {
      onError(e);
    }
  }

  return {
    deleteKeyResult,
    loading,
    error,
  };
};
